var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.localVisible && _vm.isReady,
          expression: "localVisible && isReady",
        },
      ],
      staticClass: "fc-popup-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.close($event)
        },
      },
    },
    [
      _c(
        "transition",
        { on: { "after-leave": _vm.onAfterLeave } },
        [
          _c(
            _vm.type,
            {
              tag: "component",
              attrs: {
                env: _vm.env,
                title: _vm.title,
                subtitle: _vm.subtitle,
                imageUrl: _vm.imageUrl,
                slug: _vm.slug,
                buttonText: _vm.buttonText,
                buttonIcon: _vm.buttonIcon,
                cancelButtonText: _vm.cancelButtonText,
              },
              on: {
                callback: _vm.callback,
                close: _vm.close,
                cancel: _vm.cancel,
                "confirm-callback": _vm.confirmCallback,
              },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }